import { LongFrameRecord } from '../longest-animation-frame';

export function getLoAFAdditionalParams({ scriptTimings, relatedInteractions }: Omit<LongFrameRecord, 'duration'>) {
    return {
        scripts:
            scriptTimings
                .map(
                    scriptTiming =>
                        `${scriptTiming.sourceURL}:${scriptTiming.sourceCharPosition}:${scriptTiming.invoker}`
                )
                .join(';') || 'unknown',
        scriptDurations: scriptTimings.map(x => x.duration).join(';') || 'unknown',
        interactions: relatedInteractions.map(x => `${x.selector}.${x.eventType}`).join(';') || 'unknown',
    };
}
